import {Model} from "@vuex-orm/core";

export default class CustomerCustomerTag extends Model {

    static entity = 'customerCustomerTags';

    static primaryKey = ['customer_id', 'customer_tag_id'];

    static fields () {
        return {
            customer_id: this.attr(null),
            customer_tag_id: this.attr(null),
        }
    }
}
